import {UI} from "../../../../../stem-core/src/ui/UIBase";

import {BasePanelPage} from "../../../PanelPage";
import {Messages} from "../../../../Messages";
import {MerchantButton} from "../../../../common/MerchantButton";
import {Router} from "../../../../../stem-core/src/ui/Router";
import {LoadingSpinner} from "../../../../../core/ui/LoadingSpinner.jsx";
import {apiDeletePaymentMethod, PaymentMethodStore} from "../../../../../client/state/PaymentMethodStore";
import {registerStyle} from "../../../../../stem-core/src/ui/style/Theme";
import {InlineUserDashboardPanelStyle} from "./InlineUserDashboardPanelStyle";
import {autoredraw} from "../../../../../stem-core/src/decorators/AutoRedraw";
import {Flow} from "../../../initializeFlows";
import {Toast} from "../../../../ui/Toast.jsx";


@autoredraw(PaymentMethodStore)
@registerStyle(InlineUserDashboardPanelStyle)
export class InlineUserDashboardRemoveCardPanel extends BasePanelPage {
    getDefaultOptions() {
        return {
            ...super.getDefaultOptions(),
            title: Messages.removeCard,
        };
    }

    async removeCard() {
        LoadingSpinner.show();
        try {
            await apiDeletePaymentMethod(Flow.dashboard.card.id);
            Router.back();
            Toast.showSuccess(Messages.cardRemoved);
        } catch (error) {
            Toast.showError(error);
        } finally {
            LoadingSpinner.hide();
        }
    }

    render() {
        const {styleSheet} = this;
        const {card} = Flow.dashboard;

        return [
            <div>{Messages.removeCardEndingIn(card.getBrand(), card.getLastDigits())}</div>,
            <MerchantButton className={styleSheet.actionButton} label={Messages.remove} onClick={() => this.removeCard()}/>,
            <div className={styleSheet.backButton} onClick={() => Router.back()}>
                {Messages.cancel}
            </div>
        ];
    }
}
